// extracted by mini-css-extract-plugin
module.exports = {"overAll":"cancelsubscriptionmodal_overAll__1tOu9","warningFlex":"cancelsubscriptionmodal_warningFlex__3Tpyq","warningText":"cancelsubscriptionmodal_warningText__296yc"};